import React from "react";
import { Link, Navigate } from "react-router-dom";
import Plus from "../../assets/svgs/Plus";
import { useRootContext } from "../../context";

const AddPopup = () => {
  const { dispatch } = useRootContext();
  function hide() {
    setTimeout(() => {
      dispatch({ type: "toggle_addpopup" });
    }, 100);
  }
  return (
    <div>
      <div
        onClick={() => dispatch({ type: "toggle_addpopup" })}
        className="fixed inset-0 m-auto w-full h-full bg-black bg-opacity-5"
      />
      <div
        style={{ boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.25)" }}
        className="flex flex-col space-y-3 h-fit absolute top-[96px] right-8 z-50 p-10 bg-white rounded-md"
      >
        <Link to="/new-employee">
          <button
            onClick={() => {
              hide();
              dispatch({ type: "toggle_hiddenLeftbarWhenShowForms" });
            }}
            className="filter drop-shadow-md bg-gradient-to-tr from-[#FA4A6F] to-[#BA004F] py-2 px-4 w-72 text-left text-lg text-white rounded flex items-center justify-between focus:ring"
          >
            <span>Add Employee</span>
            <Plus />
          </button>
        </Link>
        <Link to="/new-company">
          <button
            onClick={() => {
              hide();
              dispatch({ type: "toggle_hiddenLeftbarWhenShowForms" });
            }}
            className="filter drop-shadow-md bg-gradient-to-tr from-[#FA4A6F] to-[#BA004F] py-2 px-4 w-72 text-left text-lg text-white rounded flex items-center justify-between focus:ring"
          >
            <span>Add Company</span>
            <Plus />
          </button>
        </Link>
        <Link to="/employee-view">
          <button
            onClick={hide}
            className="filter drop-shadow-md bg-gradient-to-tr from-[#FA4A6F] to-[#BA004F] py-2 px-4 w-72 text-left text-lg text-white rounded flex items-center justify-between focus:ring"
          >
            <span>Employee View</span>
            <Plus />
          </button>
        </Link>
        <Link to="/company-view">
          <button
            onClick={hide}
            className="filter drop-shadow-md bg-gradient-to-tr from-[#FA4A6F] to-[#BA004F] py-2 px-4 w-72 text-left text-lg text-white rounded flex items-center justify-between focus:ring"
          >
            <span>Company View</span>
            <Plus />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AddPopup;
